// миксин, добавляющий поле state

const data = function () {
    return { state: "" };
};

const methods = {
    setState(state) {
        this.state = state;
    },
};

export default {
    data,
    methods,
};
